import { render, staticRenderFns } from "./Users_skills.vue?vue&type=template&id=1ef8118f&scoped=true&lang=pug&"
import script from "./Users_skills.vue?vue&type=script&lang=coffee&"
export * from "./Users_skills.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef8118f",
  null
  
)

export default component.exports